import { render, staticRenderFns } from "./OneSubmissionCard.vue?vue&type=template&id=a655bd7c&scoped=true&"
import script from "./OneSubmissionCard.vue?vue&type=script&lang=ts&"
export * from "./OneSubmissionCard.vue?vue&type=script&lang=ts&"
import style0 from "./OneSubmissionCard.vue?vue&type=style&index=0&id=a655bd7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a655bd7c",
  null
  
)

export default component.exports